<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-share-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <h5 class="title"></h5>
                <div class="dialog-body">

                    <div class="reward-view" v-if="giftList.length">
                        <div class="reward-item" v-for="(item,index) in giftList" :key="index">
                            <div class="r-wrapper">
                                <div class="pic" v-tips="item.giftId">
                                    <game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item>
                                </div>
                            </div>                                
                        </div>
                    </div>                    

                    <div class="text">分享页面给更多玩家，完成助力领好礼</div>
                </div>

                <div class="u-btn share" @click="call_copy()"></div>      
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            text : '分享专属链接 召回你的老友',
            shareTxt : '分享专属链接 召回你的老友',
            gid : '',
            giftList : [{ giftId : 'MG80', sendNum : 1 },{ giftId : 'MS63', sendNum : 500 },{ giftId : 'F887', sendNum : 300 },{ giftId : '1', sendNum : 600 },],
        }
    },
    created (){
        //this.render();
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              _this.$toast("复制成功");
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },
        render() {
            var _this = this;
            this.$axios.get(ajax_url_map.invite_list)
            .then(res => {
                console.log(res);
                _this.invite_list = res.data;
            },rej => {
                _this.$toast('请稍后再试')
                _this.shareTxt = '请稍后再试'
            });
        },
        call_copy (){
            this.$copy_modal({mode : 1});
            this.destroyElement();
        },       
    },
}
</script>

<style scoped>
/* share */

.m-share-modal {
    position: relative;
    width: 629px;
    height: 379px;
    font-size: 22px;
    color: #47505a;
    background-image: url(~@/assets/images/modal/bg-modal-share.png);
}

h5.title{
    width: 516px;
    height: 55px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/modal/title-webshare.png);    
}

.m-share-modal h6 {
    /* height: 14px; */
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 15px;
}

.text {
    padding: 0 45px;
    font-size: 22px;
    color: #47505a;
    word-break: break-all;
    text-align: center;
}

.reward-view{
    display: flex;
    justify-content: space-between;
    padding: 0 57px;
    margin: 30px 0 18px;
}

.reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 104px;
    height: 104px;
    background-image: url(~@/assets/images/modal/bg-item.png);   
}

.r-wrapper{
    width: 68px;
    height: 68px;
}

.r-wrapper>.pic{
    width: 100%;
    height: 100%;
}

.u-btn.share {
    position: absolute;
    left: 50%;
    bottom: 25px;
    width: 239px;
    height: 84px;
    transform: translateX(-50%);
    background-image: url(~@/assets/images/modal/btn-share.png);
}
</style>



// WEBPACK FOOTER //
// src/components/ShareModal/shareModal.vue